export default __webpack_public_path__ + "static/media/jobs-benefits-small-team.c412631a.png";